import store from '@/store/index';
export const can = (permission) => {
  const permissions = Array.from(new Set(store.getters['AuthStore/getUserPermissions'])) ?? []
  const isAdmin = store.getters['AuthStore/getUserType'] == 'admin' ? true : false
  // const behaviour = binding.modifiers.disable ? 'disable' : 'hide'
  const isPermissionExist = permissions.includes(permission)
  return isAdmin || isPermissionExist
}